import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'web-storage';
import * as i3 from 'ngx-permissions';
import * as i4 from 'idle';
import * as i5 from 'app-services-library';

class AuthenticationService {
    constructor(http, webStorage, permissionsService, idleService, sessionRelatedServiceService) {
        this.http = http;
        this.webStorage = webStorage;
        this.permissionsService = permissionsService;
        this.idleService = idleService;
        this.sessionRelatedServiceService = sessionRelatedServiceService;
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    ngOnInit() {
        this.domainName = window.location.host;
        const regexExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi;
        let footerNameString = regexExp.test(this.domainName);
        if (footerNameString == false && this.domainName == 'imagility.co' || footerNameString == true || footerNameString == false && this.domainName == 'localhost:4200') {
            this.domainName = 'imagility.co';
        }
    }
    // public jwtHelper: JwtHelperService = new JwtHelperService(); // temp fix - don't delete
    login(username, password) {
        let domainName = this.domainName;
        const payload = {
            username,
            password,
            jwt: null,
            appName: null,
            domainName
        };
        return this.http.post(`/authenticate`, payload)
            .pipe(map((user) => {
            if (user && user.status === 200) {
                if (user.data['linkRequestCode'] == null || user.data['linkRequestCode'] == null)
                    this.mapUserData(user);
            }
            else {
                sessionStorage.setItem('attemptedUserName', username);
                sessionStorage.setItem('userId', user.data['userId']);
            }
            return user;
        }));
    }
    loginCheck(username, password) {
        let domainName = this.domainName;
        return this.http.post(`/authenticate`, { username, password, domainName }).pipe(map((user) => {
            return user;
        }));
    }
    loginExternalBeneficiary(username, password, linkRequestCode) {
        return this.http.post(`/authenticate/link`, { linkRequestCode, password, username })
            .pipe(map((user) => {
            return user;
        }));
    }
    logout() {
        let token = localStorage.getItem('UserToken');
        if (token && token !== 'null') {
            return this.http.post(`/authenticate/invalidate`, {
                'jwt': 'Bearer ' + token
            });
        }
        else {
            return of(null);
        }
    }
    setCookie(jwt) {
        document.cookie = "";
        var d = new Date();
        d.setTime(d.getTime() + (3600 * 1000 * 24 * 365 * 1));
        var expires = "expires=" + d.toUTCString();
        document.cookie = "UserToken=" + jwt + ";path=/;";
    }
    // validateUser(token) {
    //   let domainName = this.domainName;
    //   if (token && token !== 'null') {
    //     const jwt = 'Bearer ' + token;
    //     return this.http.post<any>(`/authenticate`, { jwt, domainName })
    //       .pipe(
    //         map((user: ImagilityBaseResponse) => {
    //           if (user && user.status === 200) {
    //             this.mapUserData(user);
    //             return user;
    //           }
    //           else {
    //             return of(null);
    //           }
    //         })
    //       );
    //   }
    //   return of(null);
    // }
    validateUser(token) {
        let domainName = this.domainName;
        if (token && token !== 'null') {
            const jwt = 'Bearer ' + token;
            let payload = { jwt, domainName };
            if ('presentApp' in sessionStorage) {
                payload = Object.assign(Object.assign({}, payload), { appName: sessionStorage.getItem('presentApp') });
            }
            return this.http.post(`/authenticate`, payload)
                .pipe(map((user) => {
                if (user && user.status === 200) {
                    this.mapUserData(user);
                    return user;
                }
                return null; // Return null if user status is not 200
            }), catchError(error => {
                console.error("Error occurred during user validation:", error);
                return of(null); // Return observable of null in case of an error
            }));
        }
        return of(null); // Return observable of null if token is not valid
    }
    mapUserData(user) {
        sessionStorage.setItem('isCredentialsExpired', user['isCredentialsExpired']);
        this.webStorage.setWebStorageItem('currentUser', user.data);
        localStorage.setItem('UserToken', user.data ? user.data['jwt'] : null);
        localStorage.setItem('userTypeRole', user.data ? user.data['userType'] : null);
        sessionStorage.setItem('userTypeRole', user.data ? user.data['userType'] : null);
        this.permissionsService.loadPermissions(user.data ? user.data['permissions'] : []);
        this.currentUserSubject.next(user.data);
    }
    clearUserData() {
        localStorage.setItem('UserToken', null);
        localStorage.setItem('userTypeRole', null);
        this.webStorage.removeWebStorageItem("currentUser");
        this.webStorage.sessionEndTimestamping(); /*IM3069*/
        this.currentUserSubject.next(null);
        this.sessionRelatedServiceService.clearSessionStorage();
        this.idleService.get().stop();
    }
    logoCalling(url) {
        return this.http.get(`/company/logo/` + url).pipe(map((response) => {
            return response;
        }));
    }
}
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage), i0.ɵɵinject(i3.NgxPermissionsService), i0.ɵɵinject(i4.IdleService), i0.ɵɵinject(i5.SessionRelatedServiceService)); };
AuthenticationService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthenticationService, factory: AuthenticationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }, { type: i3.NgxPermissionsService }, { type: i4.IdleService }, { type: i5.SessionRelatedServiceService }]; }, null); })();

/*
 * Public API Surface of authentication
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthenticationService };
//# sourceMappingURL=authentication.js.map
